import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import DefaultProfileImg from '../assets/icon_user_profile.svg';
import DefaultCapsuleImg from '../../assets/example-productivity.jpg'

// const config = {
//   apiKey: "AIzaSyB_daft5y4jIahwnBBq4QztEcAcsEncXPU",
//   authDomain: "zideup-5f0ac.firebaseapp.com",
//   databaseURL: "https://zideup-5f0ac.firebaseio.com",
//   projectId: "zideup-5f0ac",
//   storageBucket: "zideup-5f0ac.appspot.com",
//   messagingSenderId: "415936710422"
// };

// const config = {
//   apiKey: "AIzaSyB_daft5y4jIahwnBBq4QztEcAcsEncXPU",
//   authDomain: "zideup-5f0ac.firebaseapp.com",
//   databaseURL: "https://zideup-5f0ac.firebaseio.com",
//   projectId: "zideup-5f0ac",
//   storageBucket: "zideup-5f0ac.appspot.com",
//   messagingSenderId: "415936710422"
// };

//DEV
// const config = {
//   apiKey: "AIzaSyDZ3rMbq35t7oJlLi-kihnWfaS3G9LYYt0",
//   authDomain: "zideuptests.firebaseapp.com",
//   databaseURL: "https://zideuptests.firebaseio.com",
//   projectId: "zideuptests",
//   storageBucket: "zideuptests.appspot.com",
//   messagingSenderId: "1035668996713",
// };


// PRE-PROD
// const config = {
//   apiKey: "AIzaSyAZTg0jzP4UB8f1YMJ1O5yrdy-ZO5GXQmI",
//   authDomain: "zideeup-app.firebaseapp.com",
//   databaseURL: "https://zideeup-app.firebaseio.com",
//   projectId: "zideeup-app",
//   storageBucket: "zideeup-app.appspot.com",
//   messagingSenderId: "294996669786",
//   appId: "1:294996669786:web:80db542ce0c20b21"
// }

//PROD
const config = {
  apiKey: "AIzaSyBDuXgKGsWs98tDaiOa2SFxZn-XesXnsZo",
  authDomain: "zideeup-a3f58.firebaseapp.com",
  databaseURL: "https://zideeup-a3f58.firebaseio.com",
  projectId: "zideeup-a3f58",
  storageBucket: "zideeup-a3f58.appspot.com",
  messagingSenderId: "649227713566",
  appId: "1:649227713566:web:dca4f58efe36981f"
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.storage = app.storage();
    this.auth = app.auth();
    this.db = app.firestore();
    this.db.settings({
      experimentalForceLongPolling: true
    })
    this.storage = app.storage();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      // url: 'https://zideup-dev.firebaseapp.com/',
      url: window.location.href
    });

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  user = uid => this.db.collection('users').doc(uid);

  companies = () => this.db.collection('companies');

  users = () => this.db.collection('users');

  capsules = () => this.db.collection('capsules');

  // capsule = uid => this.db.collection('capsules').doc(uid);

  // *** Image error catching ***

  profileImgError = (event) => {
    event.target.onerror = "";
    event.target.src = DefaultProfileImg;
    return true
  }

  capsuleImgError = (event) => {
    event.target.onerror = "";
    event.target.src = DefaultCapsuleImg;
    return true
  }
}

export default Firebase;
